<template>
    <CardPage :section="3" :page="4" :nextDisabled="nextDisabled" ref="cardPage">
        <p>
            To learn more, let’s play a quick matching game. Match the description to one of the four complications from the diagram.
        </p>
        <p class="font-weight-bold" v-if="currentQuizItem">
            <v-fade-transition mode="out-in">
                <span :key="currentQuizItem.question">{{ currentQuizItem.question }}</span>
            </v-fade-transition>
        </p>
        <p v-else class="font-weight-bold font-italic">You've matched all the factors!</p>
        <v-layout row wrap justify-center mb-3>
            <v-flex xs6>
                <div v-for="(key, index) in quizOrder" :key="index" @click.prevent="click(quiz[key])" class="diagram-chip answer">
                    <v-chip :color="quiz[key].color" text-color="white" class="py-2" v-ripple>{{ quiz[key].name }}</v-chip>
                    <div class="check" v-if="quiz[key].correct">
                        <v-avatar class="primary">
                            <v-icon dark>check</v-icon>
                        </v-avatar>
                    </div>
                </div>
            </v-flex>
        </v-layout>
        <ModalFeedback ref="modalFeedback"></ModalFeedback>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        quiz: get('section3/quiz'),
        quizOrder: get('section3/quizOrder'),
        currentQuizItem: get('section3/currentQuizItem')
    },
    methods: {
        click(quizItem) {
            if (this.currentQuizItem.name === quizItem.name) {
                this.$refs.modalFeedback.show(true, 'Good job!', () => {
                    this.$store.set(`section3/quiz@${quizItem.id}.correct`, true);
                    if (!this.nextDisabled()) {
                        this.$refs.cardPage.nextClick();
                    }
                });
            } else {
                this.$refs.modalFeedback.show(false, 'Try again!');
            }
        },
        nextDisabled() {
            return !!this.currentQuizItem;
        }
    }
};
</script>

<style scoped>
.answer {
    position: relative;
}
.check {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(-50%, -50%);
}
.correct {
    opacity: 0.5;
}
</style>
